export enum BORDER_RADIUS {
    NONE = 'none',
    LG = 'lg',
    '2xl' = '2xl',
    '3xl' = '3xl',
    FULL = 'full'
}